import BaseMask from "./_base.mask";

export class Decimal extends BaseMask {
  static getType() {
    return "decimal";
  }

  getValue(value, decimals = 2) {
    if (!value || value === "NaN") return "0";

    let removeMask = value.toString();

    /* Transforma em array e Limpa O que é Inválido */
    removeMask = removeMask
      .substr(0, 20)
      .replace(/[^0-9]+/g, "")
      .split("");

    /* 
      Valida se o Array tem ao menos o numero minimo de caracteres 
      Caso não tenha, preenche o array ate o numero minimo
    */
    if (removeMask.length < decimals + 2) {
      for (let i = removeMask.length; i < decimals + 2; i++) {
        removeMask.unshift("0");
      }
    }

    /* Pega valores do ultimo pra tras: Ex: Ultimo, Penultimo, Antepenultimo etc */
    const values = [];
    for (let i = 1; i <= decimals; i++) {
      values.push(removeMask[removeMask.length - i]);
    }

    /* Virgula de Acordo com a Quantidade de Casas Decimals */
    removeMask[removeMask.length - decimals] = ",";
    /* Troca a posição dos Valores caso Exista */
    for (let i = 1; i < decimals; i++) {
      removeMask[removeMask.length - i] = values[i] || "0";
    }
    removeMask[removeMask.length] = values[0] || "0";

    if (removeMask[0] === ",") {
      removeMask.unshift("0");
      removeMask.unshift("0");
    }

    if (
      removeMask.length > 5 &&
      removeMask[0] === "0" &&
      removeMask[1] !== ","
    ) {
      removeMask.splice(0, 1);
    }

    return parseFloat(removeMask.join("").replace(",", "."))
      .toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: decimals,
      })
      .replace("R$", "")
      .replace(/\s/g, "");
  }
}
